import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export default function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      get_creatives_link: {
        header: 'HEADER',
        get_link_button: 'GET_LINK_BTN',
        form: {
          merchant: 'MERCHANT',
          condition_type: 'CONDITION_TYPE',
          tracker: 'TRACKER',
          creative_type: 'CREATIVE_TYPE',
          language: 'LANGUAGE',
          size: 'SIZE',
          all_sizes: 'ALL_SIZES',
          campaign: 'CAMPAIGN',
          all_campaigns: 'ALL_CAMPAIGNS',
        },
      },
    },
  }));
}
